import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import '../Style/About.css';

gsap.registerPlugin(ScrollTrigger);

const AboutHeader = () => {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);
  const subtitleRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      // Title animation - replays on each scroll
      gsap.fromTo(titleRef.current,
        { y: 50, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );

      // Subtitle animation - replays on each scroll
      gsap.fromTo(subtitleRef.current,
        { y: 30, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 0.8,
          delay: 0.3,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 80%',
            toggleActions: 'play none none none'
          }
        }
      );
    }, sectionRef);

    return () => ctx.revert();
  }, []);

  return (
   <div className="about-header" ref={sectionRef}>
      <div className="about-overlay">
        <div className="about-content">
          <h1 className="about-title" ref={titleRef}>ABOUT US
</h1>
          <p className="about-subtitle" ref={subtitleRef}>
       Your Trusted Partner for Precision PCBA Manufacturing in Silicon Valley
          </p>
        
        </div>
      </div>

      <svg className="about-curve" viewBox="0 0 1440 100" preserveAspectRatio="none">
        <path d="M0,0 C480,100 960,100 1440,0 L1440,100 L0,100 Z" fill="#ffffff" />
      </svg>
    </div>
  );
};

export default AboutHeader;
